import { Image, StyleSheet, Text, View } from '@react-pdf/renderer';
import React from 'react';
import { withTranslation } from 'react-i18next';
import commonStyles from 'views/SpecificationDocument/DocumentView/Common/commonStyles';
const styles = StyleSheet.create({
    pointDrawingContainer: {
        marginHorizontal: commonStyles.marginHorizontal,
        marginBottom: '3%',
    },
    pointDrawingTitleWrapper: Object.assign(Object.assign({}, commonStyles.fontM), { flexDirection: 'row', fontWeight: 'bold', marginBottom: '1.5%' }),
    pointDrawingTitle: {
        marginRight: 13,
    },
    pointDrawing: {
        objectFit: 'contain',
        width: '100%',
        border: '1.5px solid #000',
        borderRadius: 4,
        padding: '1%',
        maxHeight: 455,
    },
});
function PointDrawing({ point, pointIndex, projection, t }) {
    return (React.createElement(View, { style: styles.pointDrawingContainer, wrap: false },
        React.createElement(View, { style: styles.pointDrawingTitleWrapper },
            React.createElement(Text, { style: styles.pointDrawingTitle },
                t(point.typeCode === 'DESIGNER' ? 'product_shortcut' : 'constructive_shortcut'),
                pointIndex + 1),
            React.createElement(Text, null, `${t('drawing_shortcut')} ${projection.number}.${point.photoNumber}`)),
        React.createElement(Image, { style: styles.pointDrawing, src: point.photo })));
}
export default withTranslation('specification')(PointDrawing);
